/* eslint-disable react/prop-types */
import React, { Fragment } from 'react';

import styled from 'react-emotion';

import { GridArea } from '../../layouts/helpers';

const DesktopGrid = styled.div`
  display: grid;
  grid-template:
    'image          title            priceInfo' auto
    'image          rating           priceInfo' auto
    'image          follow           priceInfo' auto
    'image          gift             priceInfo' auto
    'image          gift             payment' auto
    'hRule          hRule            hRule' auto
    'shipping       shipping         shipping' auto
    'cartActions    cartActions      cartActions' auto
    / 150px auto auto;

  grid-column-gap: ${props => props.theme.new.spacer}px;
  grid-row-gap: ${props => props.theme.new.spacer}px;
`;

const DesktopContent = props => (
  <Fragment>
    <GridArea gridArea="image">{props.logo}</GridArea>
    <GridArea gridArea="title" leftAligned>
      {props.title}
    </GridArea>
    <GridArea gridArea="priceInfo" rightAligned spaceBetween={1}>
      {props.discount}
      {props.price}
      {props.stockLabel}
    </GridArea>
    <GridArea gridArea="rating" leftAligned>
      {props.rating}
    </GridArea>
    <GridArea gridArea="follow" leftAligned>
      {props.follow}
    </GridArea>
    <GridArea gridArea="gift" leftAligned>
      {props.gift}
    </GridArea>
    <GridArea gridArea="payment">{props.payment}</GridArea>
    <GridArea gridArea="hRule">{props.hRule}</GridArea>
    <GridArea gridArea="shipping" leftAligned paddingBottom={1}>
      {props.shipping}
    </GridArea>
    <GridArea gridArea="cartActions" spaceBetweenJustified>
      {props.cartActions}
    </GridArea>
  </Fragment>
);

const DesktopView = props => (
  <DesktopGrid>
    <DesktopContent {...props} />
  </DesktopGrid>
);

export default DesktopView;
